// src/utils/pushNotifications.js
// Registers the browser for Web Push and saves the subscription to the
// backend (linked to the logged-in user's account, so the server can
// target specific users for escalation notifications).

const urlBase64ToUint8Array = (base64String) => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64  = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = atob(base64);
  return Uint8Array.from([...rawData].map((c) => c.charCodeAt(0)));
};

export async function registerEscalationPush(token) {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
    console.warn("Push notifications not supported in this browser.");
    return null;
  }

  try {
    // 1. Request permission
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.warn("Push notification permission denied.");
      return null;
    }

    // 2. Get (or wait for) the active service worker registration
    const registration = await navigator.serviceWorker.ready;

    // 3. Check if already subscribed
    let subscription = await registration.pushManager.getSubscription();

    if (!subscription) {
      // 4. Subscribe with VAPID public key
      const vapidKey = process.env.REACT_APP_VAPID_PUBLIC_KEY;
      if (!vapidKey) {
        console.error("REACT_APP_VAPID_PUBLIC_KEY is not set.");
        return null;
      }

      subscription = await registration.pushManager.subscribe({
        userVisibleOnly:   true,
        applicationServerKey: urlBase64ToUint8Array(vapidKey),
      });
    }

    // 5. Save subscription to backend (user-specific endpoint)
    const keys = subscription.toJSON().keys || {};
    await fetch("https://api.miplapp.in/public/api/push/subscribe", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        endpoint:   subscription.endpoint,
        public_key: keys.p256dh || "",
        auth_token: keys.auth   || "",
      }),
    });

    console.info("Push notification subscription registered successfully.");
    return subscription;

  } catch (error) {
    console.error("Push registration failed:", error);
    return null;
  }
}

export async function unregisterEscalationPush(token) {
  try {
    const registration  = await navigator.serviceWorker.ready;
    const subscription  = await registration.pushManager.getSubscription();

    if (!subscription) return;

    // Tell the backend to remove this endpoint
    await fetch("https://api.miplapp.in/public/api/push/unsubscribe", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ endpoint: subscription.endpoint }),
    });

    await subscription.unsubscribe();
    console.info("Push subscription removed.");

  } catch (error) {
    console.error("Push unsubscription failed:", error);
  }
}